export const formatNumber = new Intl.NumberFormat('de-CH').format;

export const roundAndFormat = (someNumber: number) => {
  return formatNumber(Math.round(someNumber));
};

/**
 * Truncates the passed number so it does not contain more than the specified decimal places. This function does NOT round the value (unlike Number.toFixed).
 */
export function truncate(num: number, decimalPlaces: number) {
  return (
    new RegExp(`([^.]+(\\.\\d{1,${decimalPlaces}})?)`).exec(
      num.toString(),
    )?.[0] ?? num.toString()
  );
}

export function clamp(value: number, lower: number, upper: number) {
  if (value < lower) return lower;
  if (upper < value) return upper;
  return value;
}
